<template>
  <section class="is-flex is-flex-direction-column">
    <div class="is-full-width">
      <SkeletonView height="12" width="100%" rounded />
      <SkeletonView height="12" width="65%" rounded />
      <SkeletonView height="12" width="15%" rounded />
    </div>
    <div v-if="hasSecondGroup" class="is-full-width m-t-15">
      <SkeletonView height="12" width="50%" rounded />
      <SkeletonView height="12" width="90%" rounded />
      <SkeletonView height="12" width="50%" rounded />
    </div>
    <template v-if="hasExpandedGroups">
      <div class="is-full-width m-t-15">
        <SkeletonView height="12" width="100%" rounded />
        <SkeletonView height="12" width="65%" rounded />
        <SkeletonView height="12" width="15%" rounded />
      </div>
      <div class="is-full-width m-t-15">
        <SkeletonView height="12" width="50%" rounded />
        <SkeletonView height="12" width="90%" rounded />
        <SkeletonView height="12" width="50%" rounded />
      </div>
    </template>
  </section>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraAnswerSkeleton',
  components: { SkeletonView },
  props: {
    isExpandedView: {
      type: Boolean,
      default: true
    },
    isCompact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSecondGroup() {
      return !this.isCompact;
    },
    hasExpandedGroups() {
      return this.isExpandedView && !this.isCompact;
    }
  }
};
</script>

<style scoped>
.b-skeleton + .b-skeleton {
  margin-top: 0 !important;
}
</style>
